// ======================================
// Admin About Page Module
// ======================================

import { icons } from '../../components.js';
import { renderAdminLayout, initAdminLayout } from './admin-layout.js';
import { aboutAPI, uploadAPI } from '../../lib/api.js';

export function renderAboutAdmin() {
    const content = `
    <div class="admin-header-actions">
      <h2 class="admin-page-subtitle">Manage "About Us" Content</h2>
      <div class="header-actions-right">
        <a href="/about" target="_blank" class="btn btn-outline">
          ${icons.globe || '🌐'} Preview Page
        </a>
        <button class="btn btn-primary" id="save-about-btn">
          ${icons.save || '💾'} Save Changes
        </button>
      </div>
    </div>

    <form id="about-form" class="admin-form-large">
      <!-- Section 1: Hero -->
      <div class="admin-card">
        <h3 class="card-title">Hero Section</h3>
        <div class="form-group">
          <label class="form-label">Hero Title</label>
          <input type="text" name="hero_title" class="form-input" placeholder="e.g. Built on Trust..." />
        </div>
        <div class="form-group">
          <label class="form-label">Hero Subtitle</label>
          <textarea name="hero_subtitle" class="form-input" rows="3" placeholder="Short description..."></textarea>
        </div>
      </div>

      <!-- Section 2: Mission & Vision -->
      <div class="admin-card">
        <h3 class="card-title">Corporate Identity</h3>
        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Mission Statement</label>
            <textarea name="mission" class="form-input" rows="4"></textarea>
          </div>
          <div class="form-group">
            <label class="form-label">Vision Statement</label>
            <textarea name="vision" class="form-input" rows="4"></textarea>
          </div>
        </div>
      </div>

      <!-- Section 3: Founder -->
      <div class="admin-card">
        <h3 class="card-title">Founder's Message</h3>
        <div class="form-group">
          <label class="form-label">Founder Name</label>
          <input type="text" name="founder_name" class="form-input" />
        </div>
        <div class="form-group">
          <label class="form-label">Message</label>
          <textarea name="founder_message" class="form-input" rows="5"></textarea>
        </div>
        <div class="form-group">
            <label class="form-label">Founder Image</label>
            <div class="image-upload-wrapper">
                <div class="current-image" id="founder-img-preview" style="width:100px;height:100px;background:#f0f0f0;margin-bottom:10px;border-radius:8px;background-size:cover;background-position:center;"></div>
                <input type="file" id="founder-img-upload" accept="image/*" style="display:none;" />
                <button type="button" class="btn btn-sm btn-outline" onclick="document.getElementById('founder-img-upload').click()">
                    Upload Photo
                </button>
                <input type="text" name="founder_image" id="founder-img-url" class="form-input" placeholder="Or enter Image URL" style="margin-top:10px;" />
            </div>
        </div>
      </div>

      <!-- Section 4: Stats -->
      <div class="admin-card">
        <h3 class="card-title">Key Statistics</h3>
        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Years Experience</label>
            <input type="number" name="years_experience" class="form-input" />
          </div>
          <div class="form-group">
            <label class="form-label">Projects Completed</label>
            <input type="number" name="projects_completed" class="form-input" />
          </div>
          <div class="form-group">
            <label class="form-label">Warranty Years</label>
            <input type="number" name="warranty_years" class="form-input" />
          </div>
        </div>
      </div>

      <!-- Section 5: Factory Info -->
      <div class="admin-card">
        <h3 class="card-title">Factory & Execution</h3>
        <div class="form-group">
          <label class="form-label">Factory Information</label>
          <textarea name="factory_info" class="form-input" rows="4"></textarea>
        </div>
      </div>

      <!-- Section 6: SEO -->
      <div class="admin-card">
        <h3 class="card-title">SEO Settings</h3>
        <div class="form-group">
          <label class="form-label">Meta Title</label>
          <input type="text" name="meta_title" class="form-input" />
        </div>
        <div class="form-group">
          <label class="form-label">Meta Description</label>
          <textarea name="meta_description" class="form-input" rows="2"></textarea>
        </div>
      </div>
    </form>
  `;

    return renderAdminLayout('about', 'About Page Editor', content);
}

export async function initAboutAdmin() {
    initAdminLayout();

    const form = document.getElementById('about-form');
    const saveBtn = document.getElementById('save-about-btn');
    const uploadInput = document.getElementById('founder-img-upload');

    // Load Initial Data
    try {
        const response = await aboutAPI.get();
        const data = response.data || {};

        // Populate form
        Object.keys(data).forEach(key => {
            const input = form.elements[key];
            if (input) {
                input.value = data[key];
            }
        });

        // Handle Image Preview
        if (data.founder_image) {
            document.getElementById('founder-img-preview').style.backgroundImage = `url('${data.founder_image}')`;
            document.getElementById('founder-img-url').value = data.founder_image;
        }

    } catch (error) {
        console.error('Failed to load about data', error);
        // Maybe show toast error
    }

    // Handle Image Upload
    if (uploadInput) {
        uploadInput.addEventListener('change', async (e) => {
            const file = e.target.files[0];
            if (!file) return;

            const btn = e.target.nextElementSibling;
            const originalText = btn.innerText;
            btn.innerText = 'Uploading...';
            btn.disabled = true;

            try {
                const response = await uploadAPI.upload(file);
                if (response.success && response.data.url) {
                    const url = response.data.url;
                    document.getElementById('founder-img-url').value = url;
                    document.getElementById('founder-img-preview').style.backgroundImage = `url('${url}')`;
                } else {
                    alert('Upload failed: ' + (response.message || 'Unknown error'));
                }
            } catch (error) {
                console.error('Upload error:', error);
                alert('Failed to upload image. Please try again.');
            } finally {
                btn.innerText = originalText;
                btn.disabled = false;
            }
        });
    }

    // Handle Save
    if (saveBtn) {
        saveBtn.addEventListener('click', async () => {
            const formData = new FormData(form);
            const data = Object.fromEntries(formData.entries());

            const originalText = saveBtn.innerHTML;
            saveBtn.innerHTML = 'Saving...';
            saveBtn.disabled = true;

            try {
                const response = await aboutAPI.update(data);
                if (response.success) {
                    alert('About page updated successfully!');
                } else {
                    alert('Failed to update: ' + response.message);
                }
            } catch (error) {
                console.error('Save error', error);
                alert('An error occurred while saving.');
            } finally {
                saveBtn.innerHTML = originalText;
                saveBtn.disabled = false;
            }
        });
    }
}
